module.exports = __webpack_public_path__ + "img/bag3.e196f150.svg";